export default function withTimeout(promise, ms, timeoutErrorHandler) {
  var timeout = new Promise(function (_, reject) {
    var id = setTimeout(function () {
      clearTimeout(id);
      reject(timeoutErrorHandler());
    }, ms);
  });
  return Promise.race([promise, timeout]);
}